import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import { Tooltip } from 'primereact/tooltip';

export const ResumenPanel = ({
  estiloTexto,
  cabecera,
  asignacionesCargadas,
  formatNumber,
  totalServicio,
  cantServicio,
  totalFacturaExenta,
  cantFacturaExenta,
  totalComun,
  cantComun,
  totalNotaCobro,
  cantNotaCobro,
  totalCivil,
  cantCivil,
  totalArriendo,
  totalFacturaAfecta,
  valorUfUsada,
  cantArriendo,
  cantFacturaAfecta,
  totalCantidades
}) => {
  const [resumenColapsado, setResumenColapsado] = useState(true);
  const cabeceras = Array.isArray(cabecera) ? cabecera : cabecera ? [cabecera] : [];
  const multipleEmpresas = cabeceras.length > 1;
  <Tooltip target=".total-tooltip-icon" position="top" />
  return (
    
    <Panel
      header={
        <div className="flex align-items-center gap-2" style={{ padding: '0.5rem' }}>
          <i className={`pi ${resumenColapsado ? 'pi-chart-bar' : 'pi-chart-line'} text-xl`} style={{ color: '#2196F3' }}></i>
          <span className="font-bold text-xl" style={{ color: '#424242' }}>
            {resumenColapsado ? 'Mostrar Resumen' : 'Ocultar Resumen'}
          </span>
        </div>
      }
      toggleable
      collapsed={resumenColapsado}
      onToggle={(e) => setResumenColapsado(e.value)}
      onClick={() => setResumenColapsado(!resumenColapsado)}
      className="cursor-pointer shadow-4"
      style={{ 
        borderRadius: '12px',
        transition: 'all 0.2s',
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        marginTop: '1.5rem',
        marginBottom: '1.5rem'
      }}
      toggleicon={resumenColapsado ? 'pi pi-chevron-down' : 'pi pi-chevron-up'}
      pt={{
        header: { 
          className: 'px-4 py-3',
          style: {
            backgroundColor: '#f8f9fa',
            borderRadius: '12px 12px 12px 12px',
            borderBottom: '1px solid #e0e0e0'
          }
        },
        content: { 
          className: 'px-4 py-4',
          style: {
            backgroundColor: '#ffffff'
          }
        },
        toggleableContent: { 
          className: 'transition-all transition-duration-400'
        }
      }}
    >
      {/* Vista de Escritorio */}
      <div className="hidden md:block">
        
          {/* <div className="field col-2">
            <span style={{ 
              ...estiloTexto, 
              textDecoration: "underline", 
              color: '#1976D2',
              fontWeight: '600'
            }}>Productos y Servicios</span>
          </div> */}
          {/* <div className="field col-2">
            <span style={{ 
              ...estiloTexto, 
              textDecoration: "underline",
              color: '#1976D2',
              fontWeight: '600'
            }}>Cantidad</span>
          </div> */}
        

        {/* Fila 1 */}
        <div className="formgrid grid">
          <div className="field col-3">
            <span style={estiloTexto}>UF Utilizada : {valorUfUsada ? `${valorUfUsada} CLP` : " No disponible"}</span>
          </div>
          {/* <div className="field col-2">
            <span style={estiloTexto}>Arriendos : {asignacionesCargadas ? formatNumber(totalArriendo) + " UF" : "Pendiente"}</span>
          </div> */}
          {/* <div className="field col-2">
            <span style={estiloTexto}>Arriendos : {asignacionesCargadas ? cantArriendo : "Pendiente"}</span>
          </div> */}
          {cabeceras.map((cabeceraEmpresa) => (
            <React.Fragment key={cabeceraEmpresa?.empresa || cabeceraEmpresa?.id || "cabecera"}>
              <div className="field col-3">
                <span style={estiloTexto}>
                  {multipleEmpresas && <strong>{cabeceraEmpresa?.empresa}: </strong>}
                  Reproceso : {cabeceraEmpresa?.reproceso}
                </span>
              </div>

              <div className="field col-3">
                <span style={estiloTexto}>
                  {multipleEmpresas && <strong>{cabeceraEmpresa?.empresa}: </strong>}
                  Ejecutado por: {cabeceraEmpresa?.ejecutor?.nombre || "No ha sido ejecutado"}
                  {cabeceraEmpresa?.fecha_ejecucion && (
                    <span className="pi pi-info-circle ml-2" style={{ color: '#1976D2', cursor: 'pointer' }} title={`Fecha ejecución: ${cabeceraEmpresa.fecha_ejecucion}`}></span>
                  )}
                </span>
              </div>

              <div className="field col-3">
                <span style={estiloTexto}>
                  {multipleEmpresas && <strong>{cabeceraEmpresa?.empresa}: </strong>}
                  Validado por: {cabeceraEmpresa?.validador?.nombre || "No ha sido validado"}
                  {cabeceraEmpresa?.fecha_validacion && (
                    <span className="pi pi-info-circle ml-2" style={{ color: '#1976D2', cursor: 'pointer' }} title={`Fecha validación: ${cabeceraEmpresa.fecha_validacion}`}></span>
                  )}
                </span>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* Fila 2 */}
        <div className="formgrid grid">
          <div className="field col-3">
            <span style={{ 
              ...estiloTexto, 
              textDecoration: "underline",
              color: '#1976D2',
              fontWeight: '600'
            }}>Documentos</span>
          </div>

          <div className="field col-2">
            <span style={estiloTexto}>Facturas Afectas : {asignacionesCargadas ? formatNumber(totalFacturaAfecta) + " UF" : "Pendiente"}</span>
          </div>
          {/* <div className="field col-2">
            <span style={estiloTexto}>Servicios : {asignacionesCargadas ? formatNumber(totalServicio) + " UF" : "Pendiente"}</span>
          </div>
          <div className="field col-2">
            <span style={estiloTexto}>Servicios : {asignacionesCargadas ? cantServicio : "Pendiente"}</span>
          </div> */}
          <div className="field col-2">
            <span style={estiloTexto}>Facturas Exentas : {asignacionesCargadas ? formatNumber(totalFacturaExenta) + " UF" : "Pendiente"}</span>
          </div>

          <div className="field col-2">
            <span style={estiloTexto}>Notas de Cobro : {asignacionesCargadas ? formatNumber(totalNotaCobro) + " UF" : "Pendiente"}</span>
          </div>

          <div className="field col-2">
            <span style={estiloTexto}>
              Total : {asignacionesCargadas ? (Math.trunc((totalFacturaAfecta + totalFacturaExenta + totalNotaCobro) * 100) / 100).toFixed(2) + " UF" : "Pendiente"}
            </span>
          </div>
          
        </div>

        {/* Fila 3 */}
        <div className="formgrid grid">
          <div className="field col-3">
            <span style={{ 
              ...estiloTexto, 
              textDecoration: "underline",
              color: '#1976D2',
              fontWeight: '600'
            }}>Cantidad</span>
          </div>
          
          <div className="field col-2">
            <span style={estiloTexto}>
              Facturas Afectas : {asignacionesCargadas ? cantFacturaAfecta : "Pendiente"}
            </span>
          </div>

          <div className="field col-2">
            <span style={estiloTexto}>
              Facturas Exentas : {asignacionesCargadas ? cantFacturaExenta : "Pendiente"}
            </span>
          </div>

          {/* <div className="field col-2">
            <span style={estiloTexto}>G. Común : {asignacionesCargadas ? formatNumber(totalComun) + " UF" : "Pendiente"}</span>
          </div>
          <div className="field col-2">
            <span style={estiloTexto}>G. Común : {asignacionesCargadas ? cantComun : "Pendiente"}</span>
          </div> */}
          
          <div className="field col-2">
            <span style={estiloTexto}>
              Notas de Cobro : {asignacionesCargadas ? cantNotaCobro : "Pendiente"}
            </span>
          </div>

          <div className="field col-2">
            <span style={{estiloTexto}}>
              Total : {asignacionesCargadas ? (cantFacturaAfecta + cantFacturaExenta + cantNotaCobro) : "Pendiente"}
            </span>
          </div>
        </div>

        {/*
        <div className="formgrid grid">
          <div className="field col-2">
            <span style={estiloTexto}>Obra Civil : {asignacionesCargadas ? formatNumber(totalCivil) + " UF" : "Pendiente"}</span>
          </div>
          <div className="field col-2">
            <span style={estiloTexto}>Obra Civil : {asignacionesCargadas ? cantCivil : "Pendiente"}</span>
          </div> 
        </div>
        <div className="formgrid grid mt-3">
          <div className="field col-3"></div>
          {/* <div className="field col-2">
            <span style={{
              ...estiloTexto,
              fontWeight: 'bold',
              fontSize: '1.1rem',
              color: '#2196F3',
              borderTop: '2px solid #2196F3',
              paddingTop: '8px',
              display: 'inline-block'
            }}>
              Total ≈ {asignacionesCargadas ? (Math.trunc((totalArriendo + totalServicio + totalCivil + totalComun) * 100) / 100).toFixed(2) + " UF" : "Pendiente"}
            </span>
          </div> */}
          {/* <div className="field col-2">
            <span style={{
              ...estiloTexto,
              fontWeight: 'bold',
              fontSize: '1.1rem',
              color: '#2196F3',
              borderTop: '2px solid #2196F3',
              paddingTop: '8px',
              display: 'inline-block'
            }}>
              Total Cant.= {asignacionesCargadas ? (cantArriendo + cantServicio + cantCivil + cantComun) : "Pendiente"}
            </span>
          </div>
        </div>*/}
      </div>

      {/* Vista Móvil */}
      <div className="block md:hidden">
        <div className="flex flex-column gap-3">
          {/* Información General */}
          <div className="flex flex-column gap-2 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <div className="flex flex-column">
              <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>UF Utilizada</span>
              <span style={{...estiloTexto, fontSize: '1rem', fontWeight: '600'}}>
                {valorUfUsada ? `${valorUfUsada} CLP` : "No disponible"}
              </span>
            </div>
            {cabeceras.map((cabeceraEmpresa) => (
              <React.Fragment key={cabeceraEmpresa?.empresa || cabeceraEmpresa?.id || "cabecera-mobile"}>
                <div className="flex flex-column">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {multipleEmpresas ? `${cabeceraEmpresa?.empresa} - Reproceso` : "Reproceso"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '1rem', fontWeight: '600'}}>{cabeceraEmpresa?.reproceso || "No disponible"}</span>
                </div>
                <div className="flex flex-column">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {multipleEmpresas ? `${cabeceraEmpresa?.empresa} - Ejecutado por` : "Ejecutado por"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '1rem', fontWeight: '600'}}>
                    {cabeceraEmpresa?.ejecutor?.nombre || "No ha sido ejecutado"}
                  </span>
                </div>
                <div className="flex flex-column">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {multipleEmpresas ? `${cabeceraEmpresa?.empresa} - Validado por` : "Validado por"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '1rem', fontWeight: '600'}}>
                    {cabeceraEmpresa?.validador?.nombre || "No ha sido validado"}
                  </span>
                </div>
              </React.Fragment>
            ))}
          </div>

          {/* Productos y Servicios */}
          <div className="flex flex-column gap-2 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ color: '#1976D2', fontSize: '1.1rem', marginBottom: '0.5rem' }}>Productos y Servicios</h3>
            
            <div className="flex flex-column gap-2">
              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Arriendos</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalArriendo) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantArriendo : "Pendiente"}
                  </span>
                </div>
              </div>

              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Servicios</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalServicio) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantServicio : "Pendiente"}
                  </span>
                </div>
              </div>

              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Gastos Comunes</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalComun) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantComun : "Pendiente"}
                  </span>
                </div>
              </div>

              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Obra Civil</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalCivil) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantCivil : "Pendiente"}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-content-between align-items-center mt-2 pt-2" style={{ borderTop: '2px solid #2196F3' }}>
              <span style={{...estiloTexto, fontSize: '1rem', fontWeight: 'bold', color: '#2196F3'}}>Total</span>
              <div className="flex flex-column align-items-end">
                <span style={{...estiloTexto, fontSize: '1rem', fontWeight: 'bold', color: '#2196F3'}}>
                  {asignacionesCargadas ? (Math.trunc((totalArriendo + totalServicio + totalCivil + totalComun) * 100) / 100).toFixed(2) + " UF" : "Pendiente"}
                </span>
                <span style={{...estiloTexto, fontSize: '0.9rem', color: '#2196F3'}}>
                  Cantidad Total: {asignacionesCargadas ? (cantArriendo + cantServicio + cantCivil + cantComun) : "Pendiente"}
                </span>
              </div>
            </div>
          </div>

          {/* Tipos de Documentos */}
          <div className="flex flex-column gap-2 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ color: '#1976D2', fontSize: '1.1rem', marginBottom: '0.5rem' }}>Tipos de Documentos</h3>
            
            <div className="flex flex-column gap-2">
              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Facturas Afectas</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalFacturaAfecta) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantFacturaAfecta : "Pendiente"}
                  </span>
                </div>
              </div>

              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Facturas Exentas</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalFacturaExenta) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantFacturaExenta : "Pendiente"}
                  </span>
                </div>
              </div>

              <div className="flex justify-content-between align-items-center">
                <span style={{...estiloTexto, fontSize: '0.9rem'}}>Notas de Cobro</span>
                <div className="flex flex-column align-items-end">
                  <span style={{...estiloTexto, fontSize: '0.9rem', color: '#666'}}>
                    {asignacionesCargadas ? formatNumber(totalNotaCobro) + " UF" : "Pendiente"}
                  </span>
                  <span style={{...estiloTexto, fontSize: '0.8rem', color: '#666'}}>
                    Cantidad: {asignacionesCargadas ? cantNotaCobro : "Pendiente"}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-content-between align-items-center mt-2 pt-2" style={{ borderTop: '2px solid #2196F3' }}>
              <span style={{...estiloTexto, fontSize: '1rem', fontWeight: 'bold', color: '#2196F3'}}>Total</span>
              <div className="flex flex-column align-items-end">
                <span style={{...estiloTexto, fontSize: '1rem', fontWeight: 'bold', color: '#2196F3'}}>
                  {asignacionesCargadas ? (Math.trunc((totalFacturaAfecta + totalFacturaExenta + totalNotaCobro) * 100) / 100).toFixed(2) + " UF" : "Pendiente"}
                </span>
                <span style={{...estiloTexto, fontSize: '0.9rem', color: '#2196F3'}}>
                  Cantidad Total: {asignacionesCargadas ? (cantFacturaAfecta + cantFacturaExenta + cantNotaCobro) : "Pendiente"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  );
};

